import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { FileText } from 'lucide-react';
import { LegalDocumentEditor } from '@/components/admin/legal/LegalDocumentEditor';
import { LegalDocumentVersionHistory } from '@/components/admin/legal/LegalDocumentVersionHistory';
import { ActiveDocumentCard } from '@/components/admin/legal/ActiveDocumentCard';
import { DOCUMENT_TYPE_CONFIG, type LegalDocumentType } from '@/hooks/useLegalDocuments';

const DOCUMENT_TYPES: LegalDocumentType[] = ['terms-of-service', 'privacy-policy', 'po-terms', 'po-terms-summary'];

export default function AdminLegalDocumentsPage() {
  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-primary/10">
          <FileText className="h-6 w-6 text-primary" />
        </div>
        <div>
          <h1 className="text-2xl font-bold">Legal Document Management</h1>
          <p className="text-muted-foreground">
            Manage platform legal documents with version control
          </p>
        </div>
      </div>

      {/* Document Type Tabs */}
      <Tabs defaultValue="terms-of-service" className="space-y-6">
        <TabsList>
          {DOCUMENT_TYPES.map((type) => (
            <TabsTrigger key={type} value={type}>
              {DOCUMENT_TYPE_CONFIG[type].label}
            </TabsTrigger>
          ))}
        </TabsList>

        {DOCUMENT_TYPES.map((type) => (
          <TabsContent key={type} value={type} className="space-y-6">
            <ActiveDocumentCard documentType={type} />
            <LegalDocumentEditor documentType={type} />
            <LegalDocumentVersionHistory documentType={type} />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
